import { ReactElement, useState } from "react";
import Image from "next/image";

interface VideoProps{
    videoSrc?: string;
    videoThumb?: string;
}

export default function MediaWithText(props: VideoProps){
    const [play, setPlay] = useState(false);

    return (
        <>
            {!play ? (
                <button 
                    className="relative w-full h-full cursor-pointer"
                    onClick={() => setPlay(true)}
                >
                    <Image
                        src={props.videoThumb ?? ""}
                        title="Immobilienverwaltung"
                        alt="Immobilienverwaltung"
                        fill
                        className="absolute top-0 left-0"
                    />
                    <Image
                        src="/images/aboutUs/play.png"
                        title="Play"
                        alt="Play"
                        fill
                        className="absolute z-1 !top-1/2 !left-1/2 transform !-translate-x-1/2 !-translate-y-1/2 max-w-20 max-h-20"
                    />
                </button>
            ) : (
                <video
                controls
                autoPlay
                playsInline
                preload="none"
                style={{ width: "100%", height: "auto" }}
                >
                <source src={props.videoSrc} type="video/mp4" />
                </video>
            )}
        </>
    );
}